import { type QueryClient, useQuery } from '@tanstack/react-query';
import { type QueryOptions } from 'typescript/types/QueryOptions';

import { getData as getVideoLibrary } from 'api/requests/GET_VIDEO_LIBRARY';

import { getQueryKey } from 'helpers/getQueryKey';

const queryKey = (id: string) => {
  return getQueryKey('VIDEO_LIBRARY', id);
};

const queryFn = (id: string) => {
  return () => {
    return getVideoLibrary(id);
  };
};

export type VideoLibrary = Awaited<ReturnType<typeof getVideoLibrary>>;

export const preloadVideoLibrary = (queryClient: QueryClient, id: string) => {
  return queryClient.fetchQuery({ queryFn: queryFn(id), queryKey: queryKey(id) });
};

export const useQueryVideoLibrary = (id: string, options: QueryOptions<VideoLibrary>) => {
  return useQuery({
    queryKey: queryKey(id),
    queryFn: queryFn(id),
    ...options,
  });
};
